


import { HTMLAttributes, ReactElement } from "react";

interface Props extends HTMLAttributes<HTMLElement> {
    color?: string;
    myStyle?:string;
}
    
     function Reply({ color , myStyle}: Props): ReactElement {

    return (
       <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={myStyle ? myStyle : ""}>
<path d="M3.75 9.99967L7.91667 5.83301M3.75 9.99967L7.91667 14.1663M3.75 9.99967L12.0833 9.99967C13.4722 9.99967 16.25 10.833 16.25 14.1663" stroke={color ? color : "white"} strokeLinecap="round" strokeLinejoin="round"/>
</svg>
    );
}

export default Reply;